// src/components/guide/ConfirmClearSample.jsx
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useGuide } from '../../contexts/GuideContext';

export default function ConfirmClearSample() {
  const { setConfirmClear, clear } = useGuide();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const run = async () => {
    setBusy(true); setError('');
    try {
      const { failed } = await clear();
      if (failed.length) setError(`${failed.length} sample record${failed.length === 1 ? '' : 's'} could not be removed. Try again.`);
      else setConfirmClear(false);
    } catch (e) { setError(e.message || 'Could not clear the sample product.'); } finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={open => !open && !busy && setConfirmClear(false)}><DialogContent aria-label="Clear sample product" className="v2-dialog">
    <DialogHeader><DialogTitle>Clear the Pathwise sample?</DialogTitle></DialogHeader>
    <p>This removes every sample record you haven’t claimed. Your own records and anything you marked “Make it mine” stay.</p>
    {error && <p className="v2-error" role="alert">{error}</p>}
    <div className="v2-actions"><button type="button" className="v2-button" disabled={busy} onClick={run}>{busy ? 'Clearing…' : 'Clear sample product'}</button><button type="button" className="v2-button secondary" disabled={busy} onClick={() => setConfirmClear(false)}>Keep it</button></div>
  </DialogContent></Dialog>;
}
